import { render, staticRenderFns } from "./PGReport.vue?vue&type=template&id=dd5383ba&"
import script from "./PGReport.vue?vue&type=script&lang=js&"
export * from "./PGReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports